import React from 'react'
import NewAppointment from '../Pages/NewAppointment'
import { PageContent } from '../Pages/NewAppointment/Components'
import { useQuery } from '@tanstack/react-query'
import { getUrlParams } from '@Common/Services'
import { fetchOpenings } from '../Pages/NewAppointment/Functions'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { DeleteAppointment } from '../Pages/DeleteAppointment'

export const App = () => {
  const agencyCode = getUrlParams('agency')
  const { isSuccess, data: agency = {} } = useQuery(['agencySchedule', agencyCode], fetchOpenings(agencyCode), { enabled: !!agencyCode })

  return (
    <BrowserRouter basename='/'>
      <PageContent noCard customBackgroundUrl={!isSuccess ? false : (agency.customBackgroundAppointments || agency.customBackgroundUrl)}>
        <Routes>
          <Route path='/newAppointment/*' element={<NewAppointment />} />
          <Route path='/newAppointment/delete' element={<DeleteAppointment />} />
        </Routes>
      </PageContent>
    </BrowserRouter>
  )
}
